var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.visibility)?_c('div',{attrs:{"id":"success-fade-alert"}},[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.msg))])])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }